import request from '@/utils/request'
//新增/编辑
export const systemAddOrUpdate = (data) => request.post(`/sysSetting/addOrUpdate`,data)
//详情
export const getSystemInfo = () => request.get('/sysSetting/detail')
//系统日志
export const getSysLogList = (data) => request.post('/sysLogs/page',data)
//系统名称
export const getSystemDetails = () => request.get('/official/home/logo')


//咨询记录
export const getRecordList = (data) => request.post('/onlineApply/page',data)
//咨询记录-详情
export const getRecordDetails = (id) => request.get(`/onlineApply/detail/${id}`)
//咨询记录-保存
export const recordSave = (data) => request.post(`/onlineApply/record/save`,data)


//网站菜单
export const getWebsiteMenuList = (data) => request.post('/websiteMenu/page',data)
//编辑菜单
export const editWebsiteMenu = (data) => request.post('/websiteMenu/edit',data)
